// extracted by mini-css-extract-plugin
export default {"projectCell":"ProjectCell_projectCell__dBSSc"};